module.exports = __webpack_public_path__ + "img/google-play.7efb7ee2.svg";